import { type ReactElement } from 'react';
import { Button } from '@optimization/ssi-common';
import { type UpdateQueryParameterValues } from '../hooks/use-update-query-parameter-values';
import styles from './style.module.scss';
import toOptions from '@/utils/to-options';
import ReactSelect from '@/common/components/ReactSelect';

interface FiltersBarProperties {
  readonly countries: string[];
  readonly customers: string[];
  readonly chassisNumbers: string[];
  readonly selectedCountries: string[];
  readonly selectedCustomers: string[];
  readonly selectedChassisFilters: string[];
  readonly disabled: boolean;
  readonly updateQueryParameterValues: UpdateQueryParameterValues;
  readonly resetAllQueryParameters: () => void;
}

const FiltersBar = ({
  countries,
  customers,
  chassisNumbers,
  selectedCountries,
  selectedCustomers,
  selectedChassisFilters,
  disabled,
  updateQueryParameterValues,
  resetAllQueryParameters,
}: FiltersBarProperties): ReactElement => {
  const countryOptions = toOptions({ items: countries });
  const customerOptions = toOptions({ items: customers });
  const chassisOptions = toOptions({ items: chassisNumbers });

  const selectedCountryOptions = toOptions({ items: selectedCountries });
  const selectedCustomerOptions = toOptions({ items: selectedCustomers });
  const selectedChassisOptions = toOptions({ items: selectedChassisFilters });

  return (
    <div className={styles.container}>
      <ReactSelect
        label="Country"
        options={countryOptions}
        selected={selectedCountryOptions}
        disabled={disabled}
        onChange={(selected) =>
          updateQueryParameterValues({
            filterKeys: { country: selected.map((option) => option.value) },
          })
        }
      />
      <ReactSelect
        label="Filter by Customer"
        options={customerOptions}
        selected={selectedCustomerOptions}
        disabled={disabled}
        onChange={(selected) =>
          updateQueryParameterValues({
            filterKeys: { customer: selected.map((option) => option.value) },
          })
        }
      />
      <ReactSelect
        label="Filter by Chassis"
        placeholder="Type chassis (min. 4 characters)"
        options={chassisOptions}
        selected={selectedChassisOptions}
        disabled={disabled}
        hideDropdownIndicator
        openMenuOnClick={false}
        minimumSearchCharacters={4}
        searchMatchMode="startsWith"
        onChange={(selected) =>
          updateQueryParameterValues({
            filterKeys: { chassisFilter: selected.map((option) => option.value) },
          })
        }
      />
      {(selectedCountries.length > 0 || selectedCustomers.length > 0 || selectedChassisFilters.length > 0) && (
        <Button text="Reset filter" variant="ghost" onClick={resetAllQueryParameters} />
      )}
    </div>
  );
};

export default FiltersBar;
